import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CompanyCategoryCreateRequestDTO, CompanyCategoryDeleteRequestDTO, CompanyCategoryDTO, CompanyCategoryList, CompanyCategoryReadByIdRequestDTO, CompanyCategoryUpdateRequestDTO } from './CompanyCategory.interface';
import { BehaviorSubject, forkJoin, map, Observable, tap } from 'rxjs';
import { CompanyCategory_create, CompanyCategory_update, CompanyCategory_delete, CompanyCategory_readById, CompanyCategory_readAll, CompanySubCategory_create, CompanySubCategory_delete, CompanySubCategory_readAll, CompanySubCategory_readByCategoryId, CompanySubCategory_readById, CompanySubCategory_update } from 'src/app/GlobalVariables';
import { CompanySubCategoryDTO, CompanySubCategoryCreateRequestDTO, CompanySubCategoryUpdateRequestDTO, CompanySubCategoryDeleteRequestDTO, CompanySubCategoryReadByIdRequestDTO, CompanySubCategoryList } from './companysubcategory.interface';

@Injectable({
  providedIn: 'root'
})
export class CompanycategoryService {

  constructor() { }

  http = inject(HttpClient);

  Categories$ = new BehaviorSubject<CompanyCategoryDTO[]>([]);
  SubCategories$ = new BehaviorSubject<CompanySubCategoryDTO[]>([]);

  updateSubCategories(categoryId: number) {
    this.Categories$.pipe(
      map(categories => {
        const selectedCategory = categories.find(c => c.categoryId === categoryId);
        return selectedCategory ? selectedCategory.child : [];
      })
    ).subscribe(subCategories => {
      this.SubCategories$.next(subCategories);
    });
  }


  FetchAllCategories() {
    forkJoin({
      categories: this.CompanyCategory_readAll(),
      subCategories: this.CompanySubCategory_readAll()
    }).subscribe(({ categories, subCategories }) => {
      const updatedCategories = categories.items.map(category => ({
        ...category,
        child: subCategories.items.filter(sub => sub.categoryId === category.categoryId)
      }));

      // Update BehaviorSubject instead of a simple array
      this.Categories$.next(updatedCategories);

    });
  }



  CompanyCategory_create(data: CompanyCategoryCreateRequestDTO): Observable<CompanyCategoryDTO> {
    return this.http.post<CompanyCategoryDTO>(CompanyCategory_create, data)
  }
  CompanyCategory_update(data: CompanyCategoryUpdateRequestDTO): Observable<CompanyCategoryDTO> {
    return this.http.post<CompanyCategoryDTO>(CompanyCategory_update, data)
  }
  CompanyCategory_delete(data: CompanyCategoryDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CompanyCategory_delete, data)
  }
  CompanyCategory_readById(data: CompanyCategoryReadByIdRequestDTO): Observable<CompanyCategoryDTO> {
    return this.http.post<CompanyCategoryDTO>(CompanyCategory_readById, data)
  }
  CompanyCategory_readAll(): Observable<CompanyCategoryList> {
    return this.http.get<CompanyCategoryList>(CompanyCategory_readAll)
  }



  CompanySubCategory_create(data: CompanySubCategoryCreateRequestDTO): Observable<CompanySubCategoryDTO> {
    return this.http.post<CompanySubCategoryDTO>(CompanySubCategory_create, data)
  }
  CompanySubCategory_update(data: CompanySubCategoryUpdateRequestDTO): Observable<CompanySubCategoryDTO> {
    return this.http.post<CompanySubCategoryDTO>(CompanySubCategory_update, data)
  }
  CompanySubCategory_delete(data: CompanySubCategoryDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CompanySubCategory_delete, data)
  }
  CompanySubCategory_readById(data: CompanySubCategoryReadByIdRequestDTO): Observable<CompanySubCategoryDTO> {
    return this.http.post<CompanySubCategoryDTO>(CompanySubCategory_readById, data)
  }
  CompanySubCategory_readAll(): Observable<CompanySubCategoryList> {
    return this.http.get<CompanySubCategoryList>(CompanySubCategory_readAll)
  }
  CompanySubCategory_readByCategoryId(data: CompanySubCategoryReadByIdRequestDTO): Observable<CompanySubCategoryList> {
    return this.http.post<CompanySubCategoryList>(CompanySubCategory_readByCategoryId, data)
  }


}
